import { render, staticRenderFns } from "./ConferenceAuditInfoModal.vue?vue&type=template&id=873db1ce"
import script from "./ConferenceAuditInfoModal.vue?vue&type=script&lang=js"
export * from "./ConferenceAuditInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports